import { BadgeStatus } from '@cas/components/data-display/badge-dot/BadgeDot';
import StatusCell from '@cas/components/data-display/status-cell/StatusCell';
import { ReactElement } from 'react';
import { EmptyCell } from '../../formatters/genericFormatters';
import { CustomCellRendererProps } from 'ag-grid-react';
import { GeofencesListModel, GeofenceState } from '@casops/store/apis/geofencesApi';
import { IRowNode, ValueGetterParams } from 'ag-grid-community';

interface GeofenceStateValue extends Pick<GeofencesListModel, 'name' | 'state'> {}

export const geofenceStateValueGetter = <TData extends GeofenceStateValue>({
  data,
}: ValueGetterParams<TData, GeofenceStateValue>): GeofenceStateValue | null | undefined => {
  return data
    ? {
        name: data.name,
        state: data.state,
      }
    : null;
};

export const geofenceStateComparator = <T extends GeofenceStateValue>(
  valueA: unknown,
  valueB: unknown,
  nodeA: IRowNode<T>,
  nodeB: IRowNode<T>,
  isDescending: boolean,
): number => {
  if (typeof nodeA.data !== 'undefined' && typeof nodeB.data !== 'undefined') {
    return nodeA.data.name.localeCompare(nodeB.data.name);
  }
  return 0;
};

export default function GeofenceStateCellRenderer({
  value,
}: CustomCellRendererProps<GeofenceStateValue, GeofenceStateValue>): ReactElement | string {
  if (value) {
    if (value.state === GeofenceState.RequireAttention) {
      return <StatusCell label={value.name} status={BadgeStatus.Danger} />;
    }
    return value.name;
  }
  return EmptyCell;
}
